import './styles.scss'

import React from 'react'
import { map } from 'ramda'
import data from '../data'

export default class View extends React.Component {
  render() {
    return (
      <div className="view">
        <div className="header">
          <div className="header-content">
            <div className="links-cont">
              <a className="link" href="/velograph-user-manual_en.pdf">
                User manual (PDF, 6.8mb)
              </a>
              <a className="link" href="/velograph-user-manual_ru.pdf">
                Руководство пользователя (PDF, 3.2mb)
              </a>
            </div>
          </div>
        </div>
        <div className="section first-section">
          <div className="text-svg">
            <svg
              className="svg"
              x="0px"
              y="0px"
              viewBox="0 0 256.4 62.7"
              preserveAspectRatio="xMinYMin meet"
            >
              <g>
                <path
                  className="svg-path white"
                  d="M0,22.2v-6.3c1,0.9,2.3,1.7,4.1,2.3c1.7,0.6,3.4,1,4.9,1c2.4,0,3.6-0.6,3.6-1.9c0-0.7-0.4-1-0.9-1.4c-0.3-0.2-1.1-0.5-1.5-0.6L8,14.7l-1.7-0.5l-1.6-0.6c-0.7-0.3-1.2-0.5-1.6-0.7c-0.7-0.5-1.8-1.3-2.3-2.2C0.4,9.8,0,8.5,0,7.1C0,2.5,3.6,0,9.3,0c2.9,0,5.6,0.6,8.1,2v5.9c-1.1-0.6-2.3-1.2-3.8-1.6c-1.5-0.4-2.9-0.7-4.2-0.7c-2.1,0-3.1,0.5-3.1,1.6c0,0.4,0.3,0.8,1,1.1l1.1,0.4c0.7,0.2,2.3,0.6,3.3,1c2.3,0.7,4.1,1.7,5.4,2.8c1.3,1.1,1.9,2.7,1.9,4.8c0,2.3-0.9,4.2-2.7,5.6c-1.8,1.4-4.1,2.1-7,2.1C5.5,24.7,2.5,23.9,0,22.2z"
                />
                <path
                  className="svg-path white"
                  d="M24.8,24.3V0.5h6.1l6,9.1L43,0.5H49v23.8h-6.1V9.8l-4.2,6.4h-3.4l-4.4-6.4v14.5H24.8z"
                />
                <path
                  className="svg-path white"
                  d="M54,24.3L64,0.3h5.9l10,23.9h-6.6l-2-5h-8.8l-2,5H54z M64.4,14.3h5L66.9,8L64.4,14.3z"
                />
                <path
                  className="svg-path white"
                  d="M84.9,24.3V0.5H91v18.4h11.4v5.4H84.9z"
                />
                <path
                  className="svg-path white"
                  d="M107.9,24.3V0.5h6.1v18.4h11.4v5.4H107.9z"
                />
                <path
                  className="svg-path white"
                  d="M139.5,24.3V0.5h6.1v8.5h9V0.5h6.1v23.8h-6.1v-9.9h-9v9.9H139.5z"
                />
                <path
                  className="svg-path white"
                  d="M167.7,24.3V0.5h18.1v5.4h-12v3.2h9.5v5.2h-9.5v4.7H186v5.4H167.7z"
                />
                <path
                  className="svg-path white"
                  d="M190,24.3l10-23.9h5.9l10,23.9h-6.6l-2-5h-8.8l-2,5H190z M200.4,14.3h5L202.8,8L200.4,14.3z"
                />
                <path
                  className="svg-path white"
                  d="M220.8,24.3V0.5h9.5c3.9,0,7,1.1,9.5,3.3c2.4,2.2,3.7,5.1,3.7,8.6c0,3.5-1.2,6.4-3.7,8.6c-2.4,2.2-5.6,3.3-9.5,3.3H220.8z M226.9,18.9h2.9c4.6,0,7.3-2.3,7.3-6.5s-2.7-6.5-7.3-6.5h-2.9V18.9z"
                />
                <path
                  className="svg-path white"
                  d="M247.2,29.4l3.1-11.2h6.1L252,29.4H247.2z"
                />
                <path
                  className="svg-path white"
                  d="M32.5,62.3V38.5H44c4.4,0,7.4,2.1,7.4,6c0,2.3-1.3,3.9-2.8,4.6c1.2,0.3,2.2,1,3.1,2.1c0.9,1.1,1.4,2.5,1.4,4.2c0,2-0.8,3.7-2.3,5c-1.5,1.3-3.6,1.9-6.2,1.9H32.5z M38.6,47.6h4.6c1.5,0,2.4-0.8,2.4-2c0-1.3-1-2.1-2.4-2.1h-4.6V47.6z M38.6,57.2h4.9c1.9,0,3-0.9,3-2.5s-1.2-2.5-3-2.5h-4.9V57.2z"
                />
                <path
                  className="svg-path white"
                  d="M59.2,62.3V38.5h6.1v23.8H59.2z"
                />
                <path
                  className="svg-path white"
                  d="M75.3,59.3c-2.5-2.3-3.7-5.3-3.7-8.9c0-3.6,1.3-6.6,3.7-8.9S81,38,84.8,38c2.5,0,4.8,0.6,6.9,1.7v5.7c-2.2-1.2-4.4-1.8-6.5-1.8c-2.2,0-3.9,0.6-5.3,1.9s-2,2.9-2,4.9c0,2.1,0.6,3.8,1.9,5c1.3,1.2,2.9,1.8,4.7,1.8c1.6,0,2.9-0.4,3.8-1.1v-7.8h6.2V59c-1,1.1-2.3,1.9-4.1,2.7c-1.8,0.7-3.7,1.1-5.8,1.1C80.9,62.7,77.8,61.6,75.3,59.3z"
                />
                <path
                  className="svg-path white"
                  d="M111.4,62.3V38.5h6.1v23.8H111.4z"
                />
                <path
                  className="svg-path white"
                  d="M124.6,62.3V38.5h9.5c3.9,0,7,1.1,9.5,3.3s3.7,5.1,3.7,8.6c0,3.5-1.2,6.4-3.7,8.6s-5.6,3.3-9.5,3.3H124.6z M130.7,56.9h2.9c4.6,0,7.3-2.3,7.3-6.5s-2.7-6.5-7.3-6.5h-2.9V56.9z"
                />
                <path
                  className="svg-path white"
                  d="M153.4,62.3V38.5h18.1v5.4h-12v3.2h9.5v5.2h-9.5v4.7h12.2v5.4H153.4z"
                />
                <path
                  className="svg-path white"
                  d="M175.6,62.3l10-23.9h5.9l10,23.9h-6.6l-2-5h-8.8l-2,5H175.6z M186,52.3h5l-2.5-6.4L186,52.3z"
                />
                <path
                  className="svg-path white"
                  d="M205.7,60.2v-6.3c1,0.9,2.3,1.7,4.1,2.3c1.7,0.6,3.4,1,4.9,1c2.4,0,3.6-0.6,3.6-1.9c0-0.7-0.4-1-0.9-1.4c-0.3-0.2-1.1-0.5-1.5-0.6l-2.1-0.6l-1.7-0.5l-1.6-0.6c-0.7-0.3-1.2-0.5-1.6-0.7c-0.7-0.5-1.8-1.3-2.3-2.2c-0.4-0.8-0.8-2.1-0.8-3.5c0-4.6,3.6-7.1,9.3-7.1c2.9,0,5.6,0.6,8.1,2v5.9c-1.1-0.6-2.3-1.2-3.8-1.6c-1.5-0.4-2.9-0.7-4.2-0.7c-2.1,0-3.1,0.5-3.1,1.6c0,0.4,0.3,0.8,1,1.1l1.1,0.4c0.7,0.2,2.3,0.6,3.3,1c2.3,0.7,4.1,1.7,5.4,2.8s1.9,2.7,1.9,4.8c0,2.3-0.9,4.2-2.7,5.6c-1.8,1.4-4.1,2.1-7,2.1C211.2,62.7,208.2,61.9,205.7,60.2z"
                />
              </g>
            </svg>
          </div>
          <div className="image-cont">
            <div className="image-svg">
              <svg
                x="0px"
                y="0px"
                width="393px"
                height="268.1px"
                viewBox="0 0 393 268.1"
                preserveAspectRatio="xMinYMin meet"
              >
                <g>
                  <path
                    className="svg-path yellow"
                    d="M387.3,87.1c-51-51-118.7-79-190.8-79S56.7,36.2,5.7,87.1L0,81.4C52.5,28.9,122.3,0,196.5,0
		c74.2,0,144,28.9,196.5,81.4L387.3,87.1z"
                  />
                  <path
                    className="svg-path yellow"
                    d="M38.6,120l-5.7-5.7c43.7-43.7,101.8-67.8,163.6-67.8s119.9,24.1,163.6,67.8l-5.7,5.7
		c-42.2-42.2-98.2-65.4-157.9-65.4C136.9,54.6,80.8,77.9,38.6,120z"
                  />
                  <path
                    className="svg-path yellow"
                    d="M321.5,152.9c-33.4-33.4-77.8-51.8-125-51.8c-47.2,0-91.6,18.4-125,51.8l-5.7-5.7
		C100.7,112.3,147.1,93,196.5,93s95.8,19.2,130.7,54.1L321.5,152.9z"
                  />
                  <path
                    className="svg-path yellow"
                    d="M104.4,185.8l-5.7-5.7c53.9-53.9,141.7-53.9,195.6,0l-5.7,5.7C237.8,135.1,155.2,135.1,104.4,185.8z"
                  />
                  <path
                    className="svg-path yellow"
                    d="M255.7,218.7c-32.6-32.6-85.7-32.6-118.3,0l-5.7-5.7c35.8-35.8,94-35.8,129.8,0L255.7,218.7z"
                  />
                  <path
                    className="svg-path yellow"
                    d="M170.2,251.6l-5.7-5.7c8.6-8.6,19.9-13.3,32-13.3c12.1,0,23.5,4.7,32,13.3l-5.7,5.7c-7-7-16.3-10.9-26.3-10.9
		S177.2,244.6,170.2,251.6z"
                  />
                  <path
                    className="svg-path blue"
                    d="M370.8,103.6c-96.1-96.1-252.5-96.1-348.6,0l-5.7-5.7c99.3-99.3,260.8-99.3,360.1,0L370.8,103.6z"
                  />
                  <path
                    className="svg-path blue"
                    d="M337.9,136.5c-37.8-37.8-88-58.6-141.4-58.6S92.9,98.7,55.1,136.5l-5.7-5.7c81.1-81.1,213.2-81.1,294.3,0
		L337.9,136.5z"
                  />
                  <path
                    className="svg-path blue"
                    d="M305,169.4c-29-29-67.5-44.9-108.5-44.9S117,140.4,88,169.4l-5.7-5.7c30.5-30.5,71.1-47.3,114.3-47.3
		c43.2,0,83.7,16.8,114.3,47.3L305,169.4z"
                  />
                  <path
                    className="svg-path blue"
                    d="M272.1,202.3c-20.2-20.2-47.1-31.3-75.6-31.3c-28.6,0-55.4,11.1-75.6,31.3l-5.7-5.7
		c21.7-21.7,50.6-33.7,81.4-33.7s59.6,12,81.4,33.7L272.1,202.3z"
                  />
                  <path
                    className="svg-path blue"
                    d="M239.2,235.2c-11.4-11.4-26.6-17.7-42.7-17.7c-16.1,0-31.3,6.3-42.7,17.7l-5.7-5.7
		c12.9-12.9,30.2-20.1,48.5-20.1s35.5,7.1,48.5,20.1L239.2,235.2z"
                  />
                  <path
                    className="svg-path blue"
                    d="M206.3,268.1c-5.4-5.4-14.2-5.4-19.6,0l-5.7-5.7c8.6-8.6,22.5-8.6,31.1,0L206.3,268.1z"
                  />
                </g>
              </svg>
               
            </div>
            <img className="image" src="images/velograph-device.png" />
          </div>

          <div className="logo-svg">
            <svg
              x="0px"
              y="0px"
              width="208px"
              height="53px"
              viewBox="0 0 104 26.6"
              preserveAspectRatio="xMinYMin meet"
            >
              <g>
                <polygon
                  className="svg-path green"
                  points="23.1,0.6 14.9,14.8 6.8,0.6 0,0.6 14.9,26.6 29.9,0.6 	"
                />
                <polygon
                  className="svg-path green"
                  points="23,26.6 29.7,26.6 37.9,12.3 46.1,26.6 52.8,26.6 37.9,0.6 	"
                />
                <polygon
                  className="svg-path green"
                  points="45.9,0.6 60.9,26.6 64.2,20.7 56.1,6.4 72.4,6.4 75.8,0.6 	"
                />
                <rect
                  x="87.7"
                  y="0.6"
                  className="svg-path green"
                  width="5.8"
                  height="26"
                />
                <rect
                  x="98.2"
                  y="0.6"
                  className="svg-path green"
                  width="5.8"
                  height="26"
                />
                <path
                  className="svg-path green"
                  d="M81.4,7.9c-1,0-1.9-0.4-2.6-1.1c-0.7-0.7-1.1-1.6-1.1-2.6c0-1,0.4-1.9,1.1-2.7c0.7-0.7,1.6-1.1,2.6-1.1s1.9,0.4,2.6,1.1c0.7,0.7,1.1,1.6,1.1,2.6c0,1-0.4,1.9-1.1,2.7C83.3,7.5,82.4,7.9,81.4,7.9 M80.6,2.7h1c0.4,0,0.6,0.2,0.6,0.5S82,3.7,81.6,3.7h-1V2.7z M80.6,6.2V4.5h0.7l1.3,1.7h1.1l-1.3-1.8c0.6-0.2,0.9-0.6,0.9-1.2c0-0.8-0.6-1.3-1.5-1.3h-2v4.3H80.6z M77.3,4.1c0,1.1,0.4,2.1,1.2,2.9c0.8,0.8,1.8,1.2,2.9,1.2c1.1,0,2.1-0.4,2.9-1.2c0.8-0.8,1.2-1.8,1.2-2.9c0-1.1-0.4-2.1-1.2-2.9C83.5,0.4,82.6,0,81.4,0c-1.1,0-2.1,0.4-2.9,1.2C77.7,2,77.3,3,77.3,4.1"
                />
              </g>
            </svg>
             <h1 className="logo-tagline">Ultrasonic Flaw Detector</h1>
          </div>
        </div>
        <div className="section second-section">
          <div className="specifications">
            <div className="specifications-title">Technical specifications</div>
            {map(
              specification => (
                <div className="specification" key={specification.id}>
                  <p className="specification-name">{specification.name}</p>
                  <p className="specification-value">{specification.value}</p>
                </div>
              ),
              data.specifications
            )}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/view/view.js